/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Grid } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import './Pagination.css';

function Pagination({
  page,
  setPage,
  totalPages,
}) {
  // For pagination - used this for pages less than 5 display.
  const pageNumbers = [];
  // create an array of pages that will be used to map for the total pages
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  // For pagination by limit of 5 display
  const paginationArray = (total, max, current) => {
    const half = Math.round(max / 2);
    let to = max;
    if (current + half >= total) {
      to = total;
    } else if (current > half) {
      to = current + half;
    }
    const from = to - max;
    return Array.from({ length: max }, (_, i) => (i + 1) + from);
  };
  // select specific page and set the page number for api call and scrolling to top
  const selectPage = (number) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setPage(number);
  };
  // render all pages button for the parent component
  const componentTotalPage = () => {
    if (totalPages < 5) {
      return pageNumbers.map((number) => (
        <span key={number} onClick={() => selectPage(number)} className={number === page ? 'active' : ''}>{number}</span>
      ));
    }
    return paginationArray(totalPages, 5, page).map((number) => (
      <span key={number} onClick={() => selectPage(number)} className={number === page ? 'active' : ''}>{number}</span>
    ));
  };
  // backward function
  const backPage = () => {
    if (page > 1) {
      setPage(page - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    return null;
  };
  // forward function
  const forwardPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    return null;
  };
  // disable page if page is already the minimum number
  const disablePage = () => {
    if (page === 1) {
      return 'disabled';
    }
    return null;
  };
  // disable page
  const totalDisablePage = () => {
    if (page === totalPages) {
      return 'disabled';
    }
    return null;
  };
  const disableArrow = () => {
    if (page === 1) {
      return 'arrow-disabled';
    }
    return 'arrow-enabled';
  };
  const disableArrowTotal = () => {
    if (page === totalPages) {
      return 'arrow-disabled';
    }
    return 'arrow-enabled';
  };
  return (
    <Grid
      container
      alignItems='center'
      justifyContent='center'
      className='pagination-browse'
      style={{ marginTop: '20px' }}
    >
      <span
        onClick={backPage}
        className={disablePage()}
      >
        <ArrowBackIosIcon className={disableArrow()} />
      </span>
      {componentTotalPage()}
      <span
        onClick={forwardPage}
        className={totalDisablePage()}
      >
        <ArrowForwardIosIcon className={disableArrowTotal()} />
      </span>
    </Grid>
  );
}

export default Pagination;
